import type { Novidade } from './tipos';

/** Fase 2 (W32): as cores da Malgo como padrão, o login com a foto do farol e a saída com despedida. */
export const novidadeIdentidade: Novidade = {
  id: '2026-10-05-identidade',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'As cores da Malgo, o farol no login e uma saída tranquila',
      resumo: 'O sistema usa as cores da Malgo nos temas claro e escuro, o login abre com a foto do farol e sair mostra uma despedida.',
      passos: [
        'O verde da Malgo é a cor padrão, com o menu lateral em verde escuro. As outras cores seguem em Configurações, Aparência.',
        'O login abre com a logo e a cor da foto surgindo em um círculo. Uma tecla ou um toque pula direto para o formulário.',
        'Ao sair, a sessão é encerrada antes da despedida. Para voltar, use Entrar novamente.',
      ],
    },
    en: {
      titulo: 'Malgo colors, the lighthouse at sign in and a calm sign out',
      resumo: 'The system uses the Malgo colors in the light and dark themes, sign in opens with the lighthouse photo and signing out shows a farewell.',
      passos: [
        'Malgo green is the default color, with a dark green side menu. The other colors stay in Settings, Appearance.',
        'Sign in opens with the logo and the photo color appearing in a circle. Any key or tap skips straight to the form.',
        'When you sign out, the session ends before the farewell. To come back, use Sign in again.',
      ],
    },
    es: {
      titulo: 'Los colores de Malgo, el faro al entrar y una salida tranquila',
      resumo: 'El sistema usa los colores de Malgo en los dos temas, el inicio de sesión abre con la foto del faro y al salir aparece una despedida.',
      passos: [
        'El verde de Malgo es el color predeterminado, con el menú lateral en verde oscuro. Los otros colores siguen en Configuración, Apariencia.',
        'El inicio de sesión abre con el logo y el color de la foto apareciendo en un círculo. Una tecla o un toque salta directo al formulario.',
        'Al salir, la sesión se cierra antes de la despedida. Para volver, usa Entrar de nuevo.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-identidade/cores.webp', '/novidades/2026-10-05-identidade/abertura.webp', '/novidades/2026-10-05-identidade/saida.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/',
};
